const BackupCamera = () => (
  <svg width="70" height="70" viewBox="0 0 70 70" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M64.0363 44.0127C66.2668 42.0195 67.6279 39.3633 67.6279 36.4468C67.6279 33.5302 66.2668 30.874 64.0363 28.8809M61.0078 31.3583C62.4675 32.7152 63.353 34.4963 63.353 36.4468C63.353 38.3973 62.4675 40.1784 61.0078 41.5353"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <g clipPath="url(#clip0_4042_158131)">
      <path
        d="M16.0045 29.9968C11.3759 30.0555 8.24885 31.5876 6.2146 33.2251C4.21556 34.8343 3.56348 37.4809 3.56348 40.0471V43.3979C3.56348 44.5025 4.45891 45.3979 5.56348 45.3979H11.7066M16.0045 29.9968C23.3062 29.9041 35.4766 29.9532 42.9514 29.9927C43.4415 29.9953 43.9145 29.8179 44.2824 29.4942L47.2706 26.8651M16.0045 29.9968V29.9968C23.0942 19.1709 36.3567 16.756 45.8538 25.5463C46.7407 26.3671 47.2706 26.8651 47.2706 26.8651M47.2706 26.8651L47.8555 27.3783C48.9152 28.308 50.2017 28.9413 51.5849 29.2138L53.9442 29.6788C54.8816 29.8636 55.5575 30.6856 55.5575 31.6411V40.6107C55.497 42.2064 55.3754 45.3979 51.3801 45.3979L49.0994 45.3978M33.5533 19.7027V45.3979M20.355 45.3979H33.5533M33.5533 45.3979H40.5908"
        stroke="currentColor"
        strokeWidth="1.5"
      />
      <rect x="50.4492" y="32.0879" width="3.03946" height="1.72852" rx="0.864262" fill="currentColor" />
      <rect x="28.4365" y="32.0918" width="3.0477" height="1.72032" rx="0.860159" fill="currentColor" />
      <path
        d="M49.6996 45.3989C49.6996 48.0731 47.6204 50.1914 45.1154 50.1914C42.6105 50.1914 40.5312 48.0731 40.5312 45.3989C40.5312 42.7248 42.6105 40.6064 45.1154 40.6064C47.6204 40.6064 49.6996 42.7248 49.6996 45.3989Z"
        stroke="currentColor"
        strokeWidth="1.5"
      />
      <path
        d="M20.6996 45.3989C20.6996 48.0731 18.6204 50.1914 16.1154 50.1914C13.6105 50.1914 11.5312 48.0731 11.5312 45.3989C11.5312 42.7248 13.6105 40.6064 16.1154 40.6064C18.6204 40.6064 20.6996 42.7248 20.6996 45.3989Z"
        stroke="currentColor"
        strokeWidth="1.5"
      />
    </g>
    <defs>
      <clipPath id="clip0_4042_158131">
        <rect width="53.907" height="32.1551" fill="white" transform="translate(2.37207 18.9219)" />
      </clipPath>
    </defs>
  </svg>
);

export default BackupCamera;
